<template>
  <div @click="goToStepNav($event)">
    <el-steps
      class="submission__steps"
      :active="currentPage - 1"
      align-center
      simple
    >
      <el-step
        v-for="(comp, index) in children"
        :data-index="index + 1"
        :key="index"
        :status="getStatus[index]"
        :title="comp.label"
        :class="(currentPage - 1 === index) ? 'is-selected' : ''"
      />
    </el-steps>
  </div>
</template>

<script>
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';
import pageNavigationMixin from '../Mixins/pageNavigationMixin';

export default {
  mixins: [
    pageNavigationMixin,
  ],
  props: [
    'videoId',
    'seen',
  ],
  computed: {
    isStatusIncomplete() {
      const status = this.$store.state.submission[this.videoId].status;
      return SUBMISSION_STATUS.TYPE[status] === SUBMISSION_STATUS.TYPE.incomplete;
    },
    getStatus() {
      if (!this.videoId) return [];
      const stepSuccessMap = this.children.map((child, index) =>
        !this.$store.getters['submissionProgress/hasError'](this.videoId, index));


      // if submission status is incomplete, take steps seen into consideration when showing progress
      if (this.isStatusIncomplete) {
        const result = [];

        let hasSeen = false;
        for (let i = this.children.length - 1; i >= 0; i -= 1) {
          if (!hasSeen && this.seen[i]) hasSeen = true;

          if (hasSeen) {
            if (stepSuccessMap[i]) result[i] = 'success';
            else if (this.seen[i]) result[i] = 'finish';
            else result[i] = '';
          }
        }
        return result;

      // otherwise, compute progress as if all item has been seen
      } else {
        return stepSuccessMap.map((success) => {
          if (success) return 'success';
          else return 'finish';
        });
      }
    },
  },
  methods: {
    goToStepNav(event) {
      const index = event.target.parentElement.parentElement.dataset.index;
      if (index == null) return; // Stop execution is index is invalid

      this.go(index);
    },
  },
};
</script>


<style lang="scss">
.submission__component--steps {
  margin: 0 #{-$--main-padding};
  width: calc(100% + #{2 * $--main-padding});
  box-shadow: 1px 1px 1px rgba(0,0,0,0.05);
}

// Styling for Submission's steps navigation
.submission__steps .el-step {
  .el-step__title {
    text-transform: capitalize;
    white-space: pre;
    font-size: 0.8em;
  }

  .el-step__arrow {
    transform: scale(0.6);
  }
}


// Customise steps navigation to be clickable
.el-steps {
  align-self: center;
  pointer-events: none;
  box-sizing: border-box;
  height: 60px;
}

.el-step__title {
  cursor: pointer;
  pointer-events: all;
  margin: 0;
  word-break: normal !important;
}

// Make steps mobile responsive
.submission__steps {

  .el-step {
    &,
    .el-step__arrow {
      display: none;
    }

    @include breakpoint-up(sm) {
      &,
      .el-step__arrow {
        display: flex;
      }
    }
  }
  .el-step.is-selected {
    font-weight: bold;
    display: flex;
  }

  .el-step__title {
    line-height: 1.25em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/Shared/NavigationSteps.vue